import { configureStore } from '@reduxjs/toolkit';
import { userReducer } from './Reducers/UserReducer.js';
import { tcReducer } from './Reducers/tcReducer.js';
import { cReducer } from './Reducers/cReducer.js';

export default configureStore({
    reducer: {
        user: userReducer,
        tc: tcReducer,
        compare: cReducer,
    },
})

